<template>
  <div class="pc__compare-wrapper">
    <label class="pc__compare-checkbox">
      <input
        type="checkbox"
        role="checkbox"
        tabindex="0"
        autocomplete="off"
        :disabled="isDisabled"
        :checked="isChecked"
        @change="handleChange"
        :aria-label="getAriaLabel()"
      />
      <span :class="['pc__compare-label', { 'pc__compare-label--disabled': isDisabled }]"> Compare </span>
    </label>
  </div>
</template>

<script setup>
  import { computed, toRefs } from 'vue';

  const props = defineProps({
    productId: {
      type: String,
      required: true,
    },
    compareProducts: {
      type: Array,
      required: true,
    },
    maxCompareItems: {
      type: Number,
      default: 4, // Default for desktop
    },
    windowWidth: {
      type: Number,
      required: true,
    },
  });

  const { productId, compareProducts, maxCompareItems, windowWidth } = toRefs(props);
  const emit = defineEmits(['compare-change']);

  const isDisabled = computed(() => {
    return (
      compareProducts.value.length >= maxCompareItems.value &&
      !compareProducts.value.some((item) => item.id === productId.value)
    );
  });

  const isChecked = computed(() => {
    return compareProducts.value.some((item) => item.id === productId.value);
  });

  const handleChange = (event) => {
    emit('compare-change', event.target.checked, productId.value);
  };

  const getAriaLabel = () => {
    if (isChecked.value) {
      return 'Deselect this tickbox to remove product from compare';
    }
    return 'Select this tickbox to compare it with other products';
  };
</script>
